import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";
import TaxDebtOffersWrapper from "@components/layouts/taxdebtoffersWrapper";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <TaxDebtOffersWrapper>
            <TermsAndConditions
                domain="TaxDeptOffers.com"
                category="Tax Dept"
            />
        </TaxDebtOffersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
